import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'

import Maintenance from './components/Maintenance'

import Connection from '../Connection/Connection'

// DEVELOPMENT components
// import DummyPage from '../DummyPage'

// PUBLIC components
import What from '../What/What'
import Privacy from '../Footer/Privacy'
import DeleteAccount from '../Footer/DeleteAccount'

// PRIVATE components
// import PrivateHome from '../PrivateHome'
import Career from '../Career/Career'
import Todo from '../Todo/Todo'
import Expenses from '../Expenses/Expenses'
// import Budget from '../Budget'

const AllRoutes = (props) => {
  // const isConnectedUser = props.user && props.user.connected // Usefull for private menu

  const goBackToRoot = <Navigate to="/" />
  const maintenance = <Maintenance {...props} />

  const connection = <Connection {...props} />

  const what = <What {...props} />
  const privacy = <Privacy {...props} />
  const deleteAccount = <DeleteAccount {...props} />

  // const privateHome = <PrivateHome {...props} />
  const career = <Career {...props} />
  const todo = props.user?.level >= 10 ? <Todo {...props} /> : goBackToRoot
  const expenses = props.user?.level >= 50 ? <Expenses {...props}/> : goBackToRoot

  return (
    <Routes>

      {/* Root */}
      {/* <Route exact path='/' element={isConnectedUser ? privateHome : publicHome} /> */}
      <Route exact path='/' element={career} />

      {/* Backend server is down page */}
      <Route path='/maintenance' element={maintenance}/>

      <Route path='/connection' element={connection}/>

      {/*  Public pages */}
      <Route path='/what' element={what} />
      <Route path='/todo' element={todo} />
      <Route path='/expenses' element={expenses} />

      {/* Logged in pages */}

      {/* Footer routes */}
      <Route path='/privacy' element={privacy} />
      <Route path='/delete-my-account' element={deleteAccount} />

      {/* Catch All */}
      <Route path="*" element={goBackToRoot} />

    </Routes >
  )
}

export default AllRoutes
